import {useEffect, useMemo, useRef} from 'preact/hooks';

import {Button} from '~/components/Button';
import {useI18n} from '~/foundation/I18n/hooks';
import {useMonorail} from '~/foundation/Monorail/hooks';
import type {BuildAuthorizeUrlParams} from '~/types/authorizeUrlParams';

type PrequalButtonProps = Exclude<
  BuildAuthorizeUrlParams,
  'analyticsTraceId'
> & {
  disabled?: boolean;
};

export const PrequalButton = ({disabled}: PrequalButtonProps) => {
  const {translate} = useI18n();
  const {trackPageImpression} = useMonorail();

  const buttonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    trackPageImpression({page: 'SIGN_IN_WITH_SHOP_BUTTON'});
  }, [trackPageImpression]);

  const buttonText = useMemo(() => {
    return disabled
      ? translate('paymentTerms.buttons.unavailable')
      : translate('paymentTerms.buttons.check');
  }, [disabled, translate]);

  return (
    <Button
      className="m-auto flex size-full w-full cursor-pointer items-center justify-center rounded-xs border-none px-11 py-2.5 text-button-large font-normal"
      disabled={disabled}
      ref={buttonRef}
    >
      <span
        className="whitespace-nowrap font-sans text-white"
        data-testid="prequal-button-text"
      >
        {buttonText}
      </span>
    </Button>
  );
};
